import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import BlogsService from "../Services/blogs.service";

const Blog = () => {
  const location = useLocation();
  const { blogId } = location.state;

  const [blogs, setBlogs] = useState({});
  const [mainBlogs, setMainBlogs] = useState([]);
  const [blogDesc, setBlogDesc] = useState([]);
  const [blogID, setBlogID] = useState(blogId);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchBlogs();
  }, [blogID]);

  console.log("blogID", blogID)

  const fetchBlogs = () => {
    BlogsService.fetchBlogsData()
      .then((resp) => {
        if (resp.data) {
          console.log(resp.data);
          const matchedBlog = resp.data.find((blog) => blog.id === blogID);
          console.log("matchedBlog", matchedBlog)
          setMainBlogs(resp.data);
          if (matchedBlog) {
            setBlogs(matchedBlog);
            const segments = matchedBlog.description.split("\r\n\r\n");
            const formattedSegments = segments.map((segment) =>
              segment.replace(/\r\n/g, "\n")
            );
            console.log("formattedSegments", formattedSegments);
            setBlogDesc(matchedBlog.description);
          } else {
            console.error("No blog found with the specified id");
          }
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const options = {
    margin: 30,
    responsiveClass: true,
    nav: false,
    dots: true,
    autoplay: true,
    navText: ["Prev", "Next"],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1, // Changed mainBlogs to items
      },
      600: {
        items: 2, // Changed mainBlogs to items
      },
      1000: {
        items: 4, // Changed mainBlogs to items
      },
    },
  };

  return (
    <>
      <section className="blogs">
        <div className="blogs-banner">
          <div className="container-fluid">
            <div className="blogs-content">
              <div className="row">
                <div className="col-lg-6">
                  <div className="heading">
                    <div className="heading-flex">
                      <h2>{blogs.title}</h2>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img
                    src={`https://fidusindia.in/cit/assets/blog_images/${blogs.image}`}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="blogs-section">
            <div className="blogs-section-content">
              <div
                dangerouslySetInnerHTML={{
                  __html: blogDesc && blogDesc,
                }}
                data-aos="fade-up"
                data-aos-duration="1500"
              />
            </div>
            <OwlCarousel className="owl-theme" {...options} loop>
              {Array.isArray(mainBlogs) && mainBlogs.length > 0
                ? mainBlogs.map((item) => (
                    <div className="blog-item">
                      <div className="blog">
                        <img
                          src={`https://fidusindia.in/cit/assets/blog_images/${item.image}`}
                        />
                        <div className="content">
                          <h5>{item.title}</h5>
                          <p className="href" onClick={() => setBlogID(item.id)}>
                            Learn More
                          </p>
                        </div>
                        <div className="overlay3"></div>
                      </div>
                    </div>
                  ))
                : null}
            </OwlCarousel>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
